import { createSelector, createSlice } from "@reduxjs/toolkit";
import { HEADER_TITLE } from "constants/appConstant";
import { USER_ROLES } from "utils/editorConfig";

const cacheLayout = window.location.pathname;

const initialState = {
  headerTitle: HEADER_TITLE.dashboard,
  subHeaderTitle: "",
  layoutConsole: cacheLayout.includes("/admin")
    ? USER_ROLES.ADMIN
    : USER_ROLES.OPERATOR,
  isRefresh: null,
  collapsed: false,
  isRefreshDashboard: false,
};

const slice = createSlice({
  name: "layout",
  initialState: initialState,
  reducers: {
    setIsRefreshDashboard: (state, action) => {
      state.isRefreshDashboard = action.payload;
    },
    setHeaderTitle: (state, action) => {
      state.headerTitle = action.payload;
    },
    setSubHeaderTitle: (state, action) => {
      state.subHeaderTitle = action.payload;
    },
    changeLayout: (state, action) => {
      state.layoutConsole = action.payload;
      // StorageHelper.setLocalItem(STORAGE_KEYS.layout, action.payload);
    },
    setIsRefresh: (state, action) => {
      state.isRefresh = action.payload;
    },
    setCollapsedMenu: (state, action) => {
      state.collapsed = action.payload;
    },
  },
  extraReducers: {},
});

const { reducer, actions } = slice;
export const {
  setHeaderTitle,
  setSubHeaderTitle,
  changeLayout,
  setIsRefresh,
  setCollapsedMenu,
  setIsRefreshDashboard,
} = actions;
export default reducer;

export const getHeaderTitle = createSelector(
  state => state.layout.headerTitle,
  headerTitle => headerTitle
);
export const getSubHeaderTitle = createSelector(
  state => state.layout.subHeaderTitle,
  subHeaderTitle => subHeaderTitle
);
export const getLayoutConsole = createSelector(
  state => state.layout.layoutConsole,
  layoutConsole => layoutConsole
);
export const getIsRefresh = createSelector(
  state => state.layout.isRefresh,
  isRefresh => isRefresh
);
export const getCollapsed = createSelector(
  state => state.layout.collapsed,
  collapsed => collapsed
);

export const getIsRefreshDashboard = createSelector(
  state => state.layout.isRefreshDashboard,
  isRefreshDashboard => isRefreshDashboard
);
